/* CLOVEBY theme scripts */
(function () {
  'use strict';
  var C = window.CLOVEBY || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Storage (safe) ---------- */
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Header ---------- */
  function initHeader() {
    var wrap = $('[data-cb-header]');
    if (!wrap) return;
    var header = $('.cb-header', wrap);
    var setH = function () { document.documentElement.style.setProperty('--cb-header-h', wrap.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Drawer ---------- */
  function initDrawer() {
    var lastFocus;
    $$('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-drawer-open'));
        if (!d) return;
        lastFocus = btn;
        d.classList.add('is-open');
        d.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('cb-lock');
        var f = $('button, a, input', d); if (f) f.focus();
      });
    });
    var close = function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cb-lock');
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    };
    $$('.cb-drawer').forEach(function (d) {
      $$('[data-drawer-close]', d).forEach(function (b) { b.addEventListener('click', function () { close(d); }); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        $$('.cb-drawer.is-open').forEach(close);
        var f = $('.cb-filters.is-open'); if (f) f.classList.remove('is-open');
        var lb = $('[data-lightbox]:not([hidden])'); if (lb) lb.hidden = true;
      }
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = C.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    $$('[data-predictive-search]').forEach(function (wrap) {
      var input = $('input[type=search]', wrap);
      var panel = $('.cb-predictive', wrap);
      if (!input || !panel || !C.routes.predictiveSearch) return;
      var timer, controller;
      var hide = function () { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = 'AbortController' in window ? new AbortController() : null;
          var url = C.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url, controller ? { signal: controller.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
            var res = (data && data.resources && data.resources.results) || {};
            var html = '';
            var cols = res.collections || [];
            var prods = res.products || [];
            if (cols.length) {
              html += '<div class="cb-predictive__label">' + C.strings.collections + '</div>';
              cols.slice(0, 3).forEach(function (c) { html += '<a class="cb-predictive__item" role="option" href="' + c.url + '"><span class="cb-predictive__title">' + c.title + '</span></a>'; });
            }
            if (prods.length) {
              html += '<div class="cb-predictive__label">' + C.strings.products + '</div>';
              prods.forEach(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
                html += '<a class="cb-predictive__item" role="option" href="' + p.url + '"><span class="cb-predictive__thumb">' + img + '</span><span><span class="cb-predictive__title" style="display:block">' + p.title + '</span><span class="cb-predictive__price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
              });
            }
            if (!html) html = '<div class="cb-predictive__empty">' + C.strings.noResults + '</div>';
            html += '<a class="cb-predictive__all" href="' + C.routes.search + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">' + C.strings.viewAll + ' &rarr;</a>';
            panel.innerHTML = html;
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          }).catch(function () {});
        }, 220);
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) hide(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    });
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = count; });
  }
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('CbToast');
    if (!t) return;
    var txt = $('[data-toast-text]', t);
    if (txt && msg) txt.textContent = msg;
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.hidden = true; }, 400); }, 3200);
  }
  function addToCart(formData, btn, errEl) {
    var label = btn ? (btn.querySelector('[data-atc-label]') || btn) : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.classList.add('is-loading'); if (label) label.textContent = C.strings.adding; }
    if (errEl) errEl.hidden = true;
    return fetch((C.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || C.strings.error);
        return fetch((C.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast(C.strings.added);
      })
      .catch(function (err) {
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else { toast(err.message); }
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); if (label) label.textContent = original; }
      });
  }
  function initAjaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('[data-cb-add]')) {
        e.preventDefault();
        addToCart(new FormData(form), $('button[type=submit]', form));
      } else if (form.matches('[data-cb-product-form]')) {
        e.preventDefault();
        addToCart(new FormData(form), $('[data-atc]', form), $('[data-form-error]', form));
      }
    });
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = e.target.closest('[data-qty]');
      var input = $('input', wrap);
      var min = parseInt(input.min || '0', 10);
      var v = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var cartForm = $('[data-cart-form]');
    if (cartForm) {
      var t;
      cartForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cart-qty]')) return;
        clearTimeout(t);
        t = setTimeout(function () {
          var upd = $('[data-cart-update]', cartForm);
          if (upd) upd.click(); else cartForm.submit();
        }, 600);
      });
    }
  }

  /* ---------- Wishlist ---------- */
  var WKEY = 'cloveby-wishlist';
  function getWish() { return store.get(WKEY, []); }
  function syncWish() {
    var list = getWish();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.setAttribute('data-count', list.length); });
  }
  function initWishlist() {
    syncWish();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wishlist-toggle]');
      if (!b) return;
      e.preventDefault();
      var h = b.getAttribute('data-wishlist-toggle');
      var list = getWish();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      store.set(WKEY, list);
      syncWish();
      var grid = $('[data-wishlist-grid]');
      if (grid && i > -1) renderWishlist();
    });
    renderWishlist();
  }
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var list = getWish();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch((C.routes.root || '/') + 'products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      grid.innerHTML = cards.join('');
      if (!grid.innerHTML.trim() && empty) empty.hidden = false;
      syncWish();
    });
  }

  /* ---------- Slider (hero) ---------- */
  function initSliders() {
    $$('[data-cb-slider]').forEach(function (el) {
      var slides = $$('.cb-hero__slide', el);
      if (slides.length < 2) return;
      var i = 0, timer;
      var cur = $('[data-slide-current]', el);
      var bar = $('[data-slide-bar]', el);
      var speed = parseInt(el.getAttribute('data-speed'), 10) || 6000;
      var auto = el.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (cur) cur.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        restart();
      }
      function restart() {
        if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; void bar.offsetWidth; if (auto) { bar.style.transition = 'width ' + speed + 'ms linear'; bar.style.width = '100%'; } else { bar.style.width = ((i + 1) / slides.length * 100) + '%'; } }
        clearTimeout(timer);
        if (auto) timer = setTimeout(function () { go(i + 1); }, speed);
      }
      var prev = $('[data-slide-prev]', el), next = $('[data-slide-next]', el);
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      el.addEventListener('mouseenter', function () { clearTimeout(timer); if (bar) { bar.style.transition = 'none'; } });
      el.addEventListener('mouseleave', restart);
      var sx = null;
      el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); sx = null; });
      restart();
    });
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers() {
    $$('[data-scroll-prev], [data-scroll-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sec = btn.closest('section') || document;
        var sc = $$('[data-scroller]', sec).filter(function (s) { return s.offsetParent !== null; })[0];
        if (!sc) return;
        var dir = btn.hasAttribute('data-scroll-next') ? 1 : -1;
        sc.scrollBy({ left: dir * sc.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Tabs (featured) ---------- */
  function initTabs() {
    $$('[data-cb-tabs]').forEach(function (sec) {
      var btns = $$('[data-tab]', sec);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-selected', 'true');
          $$('.cb-tab-panel', sec).forEach(function (p) { p.hidden = p.id !== 'Panel-' + b.getAttribute('data-tab'); });
        });
      });
    });
    $$('[data-cb-ptabs]').forEach(function (sec) {
      var btns = $$('[data-ptab]', sec);
      var show = function (key) {
        btns.forEach(function (x) { var on = x.getAttribute('data-ptab') === key; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        $$('.cb-ptabs__panel', sec).forEach(function (p) { p.hidden = p.id !== 'PT-' + key; });
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-ptab')); }); });
      $$('a[href="#CbReviews"]').forEach(function (a) { a.addEventListener('click', function () { show('reviews'); }); });
      if (location.hash === '#CbReviews') show('reviews');
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = $('[data-filter-form]');
    var sort = $('[data-sort]');
    var submit = function () {
      if (!form) { if (sort) { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString(); } return; }
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      if (sort) params.set('sort_by', sort.value);
      location.href = form.getAttribute('action') + '?' + params.toString() + '#CbCollectionGrid';
    };
    if (form) {
      var t;
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-range-min], [data-range-max]')) return;
        clearTimeout(t); t = setTimeout(submit, e.target.type === 'number' ? 700 : 150);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      $$('[data-price-range]', form).forEach(function (pr) {
        var max = parseFloat(pr.getAttribute('data-max')) || 100;
        var rmin = $('[data-range-min]', pr), rmax = $('[data-range-max]', pr);
        var imin = $('[data-price-min]', pr), imax = $('[data-price-max]', pr);
        var fill = $('[data-range-fill]', pr);
        var paint = function () {
          var a = Math.min(+rmin.value, +rmax.value), b = Math.max(+rmin.value, +rmax.value);
          fill.style.left = (a / max * 100) + '%'; fill.style.width = ((b - a) / max * 100) + '%';
        };
        [rmin, rmax].forEach(function (r) {
          r.addEventListener('input', function () {
            var a = Math.min(+rmin.value, +rmax.value), b = Math.max(+rmin.value, +rmax.value);
            imin.value = a > 0 ? a : ''; imax.value = b < max ? b : '';
            paint();
          });
          r.addEventListener('change', function () { clearTimeout(t); t = setTimeout(submit, 300); });
        });
        paint();
      });
    }
    if (sort) sort.addEventListener('change', submit);
    var open = $('[data-filters-open]'), panel = $('#CbFilters'), close = $('[data-filters-close]');
    if (open && panel) open.addEventListener('click', function () { panel.classList.add('is-open'); });
    if (close && panel) close.addEventListener('click', function () { panel.classList.remove('is-open'); });
    document.addEventListener('click', function (e) { if (panel && panel.classList.contains('is-open') && !panel.contains(e.target) && !(open && open.contains(e.target))) panel.classList.remove('is-open'); });

    var grid = $('[data-product-grid]');
    var views = $$('[data-view]');
    if (grid && views.length) {
      var apply = function (v) {
        grid.classList.toggle('is-list', v === 'list');
        views.forEach(function (b) { var on = b.getAttribute('data-view') === v; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      };
      apply(store.get('cloveby-view', 'grid'));
      views.forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-view'); store.set('cloveby-view', v); apply(v); }); });
    }
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-product-section]').forEach(function (sec) {
      var dataEl = $('[data-product-json]', sec);
      var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], zoom: [] };
      var gallery = $('[data-gallery]', sec);
      var slides = $$('.cb-gallery-pdp__slide', sec);
      var thumbs = $$('[data-thumb]', sec);
      var current = 0;
      var show = function (n) {
        if (!slides.length) return;
        current = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-thumb') === current); });
        slides.forEach(function (s, i) { if (i !== current) { var v = s.querySelector('video'); if (v) v.pause(); } });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { if (t.hasAttribute('data-open-lightbox')) { openLb(+t.getAttribute('data-thumb')); return; } show(+t.getAttribute('data-thumb')); }); });
      if (gallery) {
        var sx = null, main = $('.cb-gallery-pdp__main', gallery);
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1)); sx = null; });
      }
      var lb = $('[data-lightbox]', sec), lbImg = $('[data-lightbox-img]', sec), lbIdx = 0;
      var openLb = function (n) {
        if (!lb || !data.zoom.length) return;
        lbIdx = typeof n === 'number' ? n : current;
        lbImg.src = data.zoom[lbIdx] || ''; lb.hidden = false;
        var c = $('[data-lightbox-close]', lb); if (c) c.focus();
      };
      $$('[data-open-lightbox]', sec).forEach(function (b) { if (!b.hasAttribute('data-thumb')) b.addEventListener('click', function () { openLb(); }); });
      if (lb) {
        $('[data-lightbox-close]', lb).addEventListener('click', function () { lb.hidden = true; });
        $('[data-lightbox-prev]', lb).addEventListener('click', function () { lbIdx = (lbIdx - 1 + data.zoom.length) % data.zoom.length; lbImg.src = data.zoom[lbIdx]; });
        $('[data-lightbox-next]', lb).addEventListener('click', function () { lbIdx = (lbIdx + 1) % data.zoom.length; lbImg.src = data.zoom[lbIdx]; });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.hidden = true; });
      }

      var form = $('[data-cb-product-form]', sec);
      if (!form) return;
      var idInput = $('[data-variant-id]', form);
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var selected = $$('fieldset', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        $$('[data-option-label]', form).forEach(function (l) { var idx = +l.getAttribute('data-option-label'); if (selected[idx]) l.textContent = selected[idx]; });
        var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); })[0];
        var atc = $('[data-atc]', form), lbl = $('[data-atc-label]', form), stock = $('[data-stock]', form);
        if (!v) { atc.disabled = true; lbl.textContent = C.strings.soldOut; return; }
        idInput.value = v.id;
        atc.disabled = !v.available;
        lbl.textContent = v.available ? C.strings.addToCart : C.strings.soldOut;
        if (stock) { stock.classList.toggle('is-out', !v.available); stock.textContent = v.available ? stock.getAttribute('data-in') || stock.textContent : C.strings.soldOut; }
        var price = $('[data-price]', sec), comp = $('[data-compare]', sec), save = $('[data-save]', sec), amt = $('[data-save-amount]', sec);
        if (price) price.innerHTML = v.price;
        if (comp) { comp.hidden = !v.compare; if (v.compare) comp.innerHTML = v.compare; }
        if (save) { save.hidden = !v.save; if (amt) amt.textContent = v.save; }
        if (v.mediaId) {
          var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.mediaId));
          if (idx > -1) show(idx);
        }
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      });
      var stock = $('[data-stock]', form); if (stock) stock.setAttribute('data-in', stock.textContent.trim());
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length && fresh.querySelector('.cb-card')) { el.innerHTML = fresh.innerHTML; syncWish(); }
      }).catch(function () {});
    });
  }

  /* ---------- Reveal ---------- */
  function initReveal() {
    var els = $$('.cb-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Account: recover toggle ---------- */
  function initAccount() {
    var login = $('[data-login-panel]'), rec = $('[data-recover-panel]');
    if (!login || !rec) return;
    var toggle = function (showRec) { rec.hidden = !showRec; login.hidden = showRec; };
    $$('[data-toggle-recover]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); toggle(rec.hidden); }); });
    if (location.hash === '#recover') toggle(true);
    $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initDrawer(); initSearch(); initAjaxAdd(); initQty(); initWishlist();
    initSliders(); initScrollers(); initTabs(); initFilters(); initProduct(); initRecs(); initReveal(); initAccount();
  });
})();
